import React, { useEffect, useState } from "react"
import { useCurrentUser } from "../components/CurrentUserContext"
import Link from "gatsby-link"
import { useTranslation } from "react-i18next"
import LogoutIcon from "../svg/log-out-icon.inline.svg"
import LogoutIconWhite from "../svg/log-out-icon-white.inline.svg"
import { openNavSchool, openNavUser } from "../scripts/loginMenus"
import SchoolIcon from "../svg/school-login.inline.svg"
import SchoolIconDark from "../svg/school-login-black.inline.svg"
import UserIcon from "../svg/user-login.inline.svg"
import UserIconDark from "../svg/user-login-black.inline.svg"
import { isSchoolRole } from "../scripts/Utils"

const UserLoginName = props => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const { currentUser, logout } = useCurrentUser()

  const [user, setCurrentUser] = useState(null)
  const [isSchoolAdmin, setIsSchoolAdmin] = useState(false)

  useEffect(() => {
    setCurrentUser(currentUser)
    setIsSchoolAdmin(isSchoolRole(currentUser))
  }, [currentUser])

  const changeColorName = entity => {
    if (
      (props && props.pathName?.includes("profile")) ||
      props?.pathName === "dark_menu"
    ) {
      if (entity === "user") {
        return "usernameBlack"
      } else if (entity === "notAuthorised") {
        return "triggered"
      } else {
        return "active"
      }
    } else if (
      (props && props.pathName?.includes("school")) ||
      props?.pathName === "white_menu"
    ) {
      return "usernameWhite"
    }
    return entity === "user" ? "usernameWhite" : ""
  }

  const changeColorIcon = entity => {
    if (
      (props && props.pathName?.includes("profile")) ||
      props?.pathName === "dark_menu"
    ) {
      if (entity === "user") {
        return <LogoutIcon className="log-out-icon" />
      } else if (entity === "notAuthorisedSchool") {
        return (
          <SchoolIconDark
            className={`school_login_icon shrinked-school-icon dark_school`}
          />
        )
      } else if (entity === "notAuthorisedUser") {
        return (
          <UserIconDark
            className={`user_login_icon shrinked-user-icon dark_user`}
          />
        )
      }
    } else if (
      (props && props.pathName?.includes("school")) ||
      props?.pathName === "white_menu"
    ) {
      if (entity === "user") {
        return <LogoutIconWhite className="log-out-icon-white" />
      } else if (entity === "notAuthorisedSchool") {
        return <SchoolIcon className={`school_login_icon`} />
      } else if (entity === "notAuthorisedUser") {
        return <UserIcon className={`user_login_icon`} />
      }
    }

    if (entity === "user") {
      return <LogoutIconWhite className="log-out-icon-white" />
    } else if (entity === "notAuthorisedSchool") {
      return <SchoolIcon className={`school_login_icon`} />
    } else if (entity === "notAuthorisedUser") {
      return <UserIcon className={`user_login_icon`} />
    }
  }

  return (
    <div>
      {user && currentUser ? (
        <div className="icon_button mR-10 user-logout">
          <Link
            to={`/${currentUser.accountType === "school" ? "en" : lang}/${
              isSchoolAdmin ? "admin-profile" : "profile"
            }`}
          >
            <div className="menu_title active username">
              <div className={changeColorName("user")}>
                {user?.firstname} {user?.lastname}
              </div>
            </div>
          </Link>
          <div onClick={logout}>{changeColorIcon("user")}</div>
        </div>
      ) : (
        <div className="f-js">
          {/* SCHOOL LOGIN */}
          <div
            className={`icon_button mR-20 ${changeColorName("notAuthorised")}`}
            onClick={openNavSchool}
          >
            <div className={`menu_title left ${changeColorName()}`}>
              {t("school.header.schoolLogin")}
            </div>
            <div>{changeColorIcon("notAuthorisedSchool")}</div>
          </div>
          {/* USER LOGIN */}
          <div
            id="logUser"
            className={`icon_button mR-20 ${changeColorName("notAuthorised")}`}
            onClick={openNavUser}
          >
            <div className={`menu_title left ${changeColorName()}`}>
              {t("school.header.userLogin")}
            </div>
            <div>{changeColorIcon("notAuthorisedUser")}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserLoginName
